import { Box, Button, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { useState, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { Link, useNavigate } from 'react-router-dom';
import '../../../alicestyle.css';
import { IoIosArrowDropleft } from 'react-icons/io';
import { handleBreakpoints } from '@mui/system';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { useTranslation } from 'react-i18next';

const { GetTutorial } = onBoardingEkycServices;

const Tutorial = ({ setShowSkip }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [itemSlide, setItemSlide] = useState(0);
  const [sliderResponseData, setSliderResponseData] = useState([]);
  const [openloader, setOpenloader] = useState(false);
  // console.log('itemSlide', itemSlide);
  // console.log('sliderResponseData', sliderResponseData);
  // const fakeAray = [
  //   {
  //     isTutorialRequired: true,
  //     heading: 'Header',
  //     description: 'Desc',
  //     seq: 1,
  //     imageUrl: null,
  //     isShowSkip: false,
  //     language: 'ENGLISH',
  //     language_code: 'EN'
  //   },
  //   {
  //     isTutorialRequired: true,
  //     heading: 'Header end',
  //     description: 'Desc hahd',
  //     seq: 3,
  //     imageUrl: null,
  //     isShowSkip: true,
  //     language: 'GUJRATI',
  //     language_code: 'GUJ'
  //   },
  //   {
  //     isTutorialRequired: true,
  //     heading: 'Headeryete',
  //     description: 'Desc 736',
  //     seq: 2,
  //     imageUrl: null,
  //     isShowSkip: false,
  //     language: 'HINDI',
  //     language_code: 'HIN'
  //   }
  // ]

  // getTutorialAPI API
  const getTutorialAPI = async () => {
    try {
      setOpenloader(true);

      const GetTutorialResponse = await GetTutorial();
      if (GetTutorialResponse.status === 'Success') {
        if (GetTutorialResponse.data.length > 0) {
          const sortSlide = GetTutorialResponse.data.sort((a, b) => a.seq - b.seq); // sorting
          setSliderResponseData(sortSlide); // sorting slide based on seq key
        } else {
          navigate('/in/selfregistration');
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  useEffect(() => {
    getTutorialAPI();
    setShowSkip(true); // static skip untill slider dynamic, if we use dynmic slider, setShowSkip true will remove, it is using from APi response
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <AliceCarousel
        // onSlideChanged={(e) => {setItemSlide(e.slide)}}
        onSlideChanged={(e) => {
          const currentSlide = e.slide;
          if (currentSlide) {
            setItemSlide(currentSlide);
            setShowSkip(sliderResponseData[currentSlide]?.isShowSkip);
          }
        }}
        autoPlay
        autoPlayInterval="3000"
        infinite={false}
      >
        {/* {sliderResponseData.length > 0 &&
          sliderResponseData.map((item, index) =>
            item?.isTutorialRequired === true ? (
              <Box id={index + 1} itemData={JSON.stringify(item)}>
                <Box className="sliderOuter" key={index}>
                  <Container maxWidth="lg">
                    <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
                      <Grid item xs={6} sx={{ textAlign: 'center' }}>
                        <img
                          src={
                            item?.imageUrl !== null
                              ? item?.imageUrl
                              : '../static/tutorialImageF.png'
                          }
                          alt={item?.heading}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'center' }}>
                        <Typography variant="h5">{item?.heading}</Typography>
                        <Typography variant="subtitle1" sx={{ width: '60%', margin: 'auto' }}>
                          {item?.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Container>
                </Box>
                <Box className="tutorialLinkBox" mt={2}>
                  {item?.isShowSkip === true ? (
                    <Link to="/in/selfregistration" className="mainBtn">
                      Continue
                    </Link>
                  ) : (
                    <Link to="/" className="circleArrow">
                      <IoIosArrowDropleft />
                    </Link>
                  )}
                </Box>
              </Box>
            ) : (
              ''
            )
          )} */}

        <Box className="sliderOuter">
          <Container maxWidth="lg">
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Box>
                  <img src="../static/tutorialImageF.png" alt="Tutorial Info Sec" />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Typography variant="h5" className="tutorialHeding">
                  {t('Capture Document')}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="tutorialSubHeding"
                  // sx={{ width: '60%', margin: 'auto' }}
                >
                  {t('You can capture a document by scanning with your camera')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box className="sliderOuter">
          <Container maxWidth="lg">
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Box>
                  <img src="../static/tutorialImageS.png" alt="Tutorial Info Sec" />
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Typography variant="h5" className="tutorialHeding">
                  {t('OCR')}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="tutorialSubHeding"
                  // sx={{ width: '60%', margin: 'auto' }}
                >
                  {t('Instant conversion to text with OCR, dont worry about typing')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Box className="sliderOuter">
          <Container maxWidth="lg">
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <img src="../static/tutorialImageT.png" alt="Tutorial Info Third" />
              </Grid>
              <Grid item xs={12} sm={12} md={6} sx={{ textAlign: 'center' }}>
                <Typography variant="h5" className="tutorialHeding">
                  {t('Review')} & {t('Submit')}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="tutorialSubHeding"
                  // sx={{ width: '60%', margin: 'auto' }}
                >
                  {t('Please check your data before submitting it')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </AliceCarousel>

      <Box className="tutorialLinkBox" mt={2}>
        {/* {itemSlide === 1 && (
          <Link to="/" className="circleArrow">
            <IoIosArrowDropleft />
          </Link>
        )} */}

        {itemSlide === 2 && (
          // <Link to="/in/selfregistration" className="mainBtn">
          //   Continue
          // </Link>
          <Box className="continueBtn">
            <Button onClick={(e) => navigate('/in/selfregistration')} className="mainBtn">
              {t('Continue')}
            </Button>
          </Box>
        )}
      </Box>
      {/* <Box className="tutorialLinkBox" mt={2}>
        {itemSlide === 1 && (
          <Link to="/" className="circleArrow">
            <IoIosArrowDropleft />
          </Link>
        )}

        {itemSlide === 2 && (
          <Link to="/in/selfregistration" className="mainBtn">
            Start self registration
          </Link>
        )}
      </Box> */}
    </>
  );
};

export default Tutorial;
